import { render, staticRenderFns } from "./bulma_modal.vue?vue&type=template&id=ca9d0c1e&scoped=true&lang=html"
import script from "./bulma_modal.vue?vue&type=script&lang=js"
export * from "./bulma_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca9d0c1e",
  null
  
)

export default component.exports